import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  standalone: false,
  selector: "formly-field-numeric-input",
  templateUrl: "./numeric-input.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldNumericInput extends FieldType<FieldTypeConfig> {
  override defaultOptions = {
    props: {
      spinners: true,
      autoCorrect: false,
      step: 1,
    },
  };

  onValueChange(event) {
    if (this.props.change) {
      this.props.change(this.field, event);
    }
  }

}
